import * as types from '../../action-types';
import {myAdvances as initialState } from "../../initialState";

const myAdvances = (state=initialState, action) => {
  switch (action.type) {
    case types.MY_ADVANCES_START:
      return {
        ...state,
        isLoading: true
      };
    case types.MY_ADVANCES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.MY_ADVANCES_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.MY_ADVANCES_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default myAdvances;
